@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/variables-dark";

@mixin custom-animation() {
  $name: inline-#{unique-id()};

  @keyframes #{$name} {
    @content;
  }

  animation-name: $name;
}

.spinner {
  --spinner-animation-speed: 1.5s;

  @include custom-animation() {
    to {
      transform: rotate(360deg);
    }
  }
  animation-duration: var(--spinner-animation-speed);
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

.bouncer {
  text-align: center;
  margin: 50px auto 25px auto;

  & span {
    --bouncer-animation-speed: 0.9s;

    display: inline-block;
    vertical-align: middle;
    width: 25px;
    height: 25px;
    margin: 5px;
    background-color: var(--#{$prefix}navy, var(--#{$prefix}rk-blue));
    border-radius: 50px;

    @include custom-animation() {
      0%,
      50% {
        opacity: 1;
        transform: translateY(0);
      }
      100% {
        opacity: 0.6;
        transform: translateY(-21px);
      }
    }
    animation-duration: var(--bouncer-animation-speed);
    animation-iteration-count: infinite;
    animation-direction: alternate;

    &:nth-of-type(2) {
      animation-delay: 0.25s;
    }
    &:nth-of-type(3) {
      animation-delay: 0.5s;
    }
  }
}
